import {BaseCurrencyCode} from '@raison/types';
import React, {Component as ReactComponent} from 'react';
import {connect} from 'react-redux';
import {legacyModalsApi, modalsTogglerClassDispatcher} from '~/entities/dialogs';
import {RsnButton, RsnDialog} from '~/library/ui-kit';
import {Crypto, Token} from '~/shared/api/legacy_services/Assets/Assets';

export type ErrorModalProps = {
    tokenSymbol?: Token['symbol'];
    tokens?: Token[];
    crypto?: Crypto[];
    currency?: BaseCurrencyCode;
    togglePopup: ReturnType<typeof modalsTogglerClassDispatcher>;
    errorModal: boolean;
    onClose?: () => void;
    error?: string | null;
};

class StripeErrorDialog extends ReactComponent<ErrorModalProps> {
    get blockchainName() {
        const {tokenSymbol, tokens, crypto, currency} = this.props;
        if (tokenSymbol) {
            return tokens?.find(item => item.symbol === tokenSymbol)?.blockchain?.name || '';
        }
        return crypto?.find(item => item.currency === currency)?.name;
    }

    get currencyName() {
        const {tokenSymbol, tokens} = this.props;
        if (tokenSymbol) {
            return tokens?.find(item => item.symbol === tokenSymbol)?.blockchain?.currency || '';
        }
        return this.props.currency;
    }

    render() {
        const {togglePopup, errorModal, onClose} = this.props;

        const toggleModal = () => togglePopup('errorModal');

        const handleClose = () => {
            onClose?.();
            toggleModal();
        };

        return (
            <RsnDialog.Controller isOpen={errorModal} onClose={handleClose}>
                <RsnDialog.Window placement='center'>
                    <RsnDialog.CenteredHeader>Causes of error</RsnDialog.CenteredHeader>
                    <RsnDialog.Body>
                        {this.props.error && <p>{this.props.error}</p>}
                        {this.props.error === undefined && (
                            <>
                                <div className='fv-text-l-regular mb-4'>
                                    Transactions occur on the {this.blockchainName} blockchain, which requires that the
                                    sender pay a fee in {this.currencyName} to ensure their transaction confirms.
                                </div>
                                <ol className='fv-text-l-regular flex flex-col gap-1 rounded-[10px] bg-[#f5f5f5] p-4 text-left'>
                                    <li className='ml-4 !list-decimal'>
                                        There aren&apos;t enough {this.currencyName} on the account <br />
                                        balance.
                                    </li>
                                    <li className='ml-4 !list-decimal'>
                                        Your {this.currencyName} balance is temporarily blocked until the previous
                                        transaction is completed.
                                    </li>
                                </ol>
                            </>
                        )}
                    </RsnDialog.Body>
                    <RsnDialog.Footer>
                        <RsnButton.Secondary type='button' onClick={toggleModal}>
                            Got it
                        </RsnButton.Secondary>
                    </RsnDialog.Footer>
                </RsnDialog.Window>
            </RsnDialog.Controller>
        );
    }
}

const mapStateToProps = (state: AppModel) => ({
    errorModal: legacyModalsApi.select('generalModals', 'errorModal')(state),
    tokens: state.assets?.assets?.accounts?.tokens,
    crypto: state.assets?.assets?.accounts?.crypto,
});

const mapDispatchToProps = {togglePopup: modalsTogglerClassDispatcher('generalModals')};

export default connect(mapStateToProps, mapDispatchToProps)(StripeErrorDialog);
